import type { FaireProductEntity } from "../../entity_types/product";

export const p_tuu6txxtve: FaireProductEntity = {
  token: "p_tuu6txxtve",
  type: "product",
  name: "Beef Tallow Potato Chips - Salt N' Vinegar",
  brandToken: "b_d6aqh4qdhb",
  brandName: "Beefy's Own",
  imageUrl:
    "https://cdn.faire.com/fastly/9094e7cbe3047d134c218496423c490cbc24163434b3ef06d3edd7c1fb58bf93.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9a73a0896206401287b303565d86a30906b2cf3b0a27cb0a7904ac62476f3bf6.png",
    "https://cdn.faire.com/fastly/1570cc616addcd93733da1f9bf5f1ed5977bd0e64785b8714ca6dfc4a6616b84.png",
    "https://cdn.faire.com/fastly/89c5aea72cfce3fb942de56a0e7f531dfbeb6e4eea8e4d06210234fbd556b3dc.png",
    "https://cdn.faire.com/fastly/120033e23a7f855394793af22e1d69f084fc9a020b652ca2a619ffa46ab5964d.png",
    "https://cdn.faire.com/fastly/756a3d3fe46b203fe0617276c751f2c7eb27dd21f50b9bf31f9891090476e4b5.png",
    "https://cdn.faire.com/fastly/39a88cdc399acf3cc382d2f249f52a7260b6221e64cd777ebf015e703f2b8ff7.png",
    "https://cdn.faire.com/fastly/7b55a6973e6a64e54b2298183151f01cc5a7990934c861c7558e18af50dcf808.png",
  ],
  priceDollars: 6.5,
  description:
    "Perfect, crispy, golden potato chips fried the old-fashioned way in pure beef tallow – bringing back old-school flavor you forgot existed. Our Salt N' Vinegar chips hit just right, striking the perfect balance between bold tangy vinegar and the rich depth of beef tallow - never too sharp, always perfectly harmonized for a crave-worthy bite. Our dedicated team of chip artisans takes pride in ensuring every chip meets the highest standards of taste and texture. From the satisfying crunch to the perfectly seasoned finish, these small-batch chips deliver a snack experience like no other.\n\n-5oz bags-\nNon-GMO Potatoes, Beef Tallow, Sea Salt, White Distilled Vinegar. (MALTODEXTRIN-FREE)",
  tags: [],
  msrpDollars: 9.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T21:11:39.148Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
